export default "__VITE_ASSET__85b43c94__"